import axios from 'axios'
// import { store } from '../store.js'

export const fetchReadinessGuides = async () => {
    const url = `/api/v1/readiness_guides`
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => resolve(response.data.status))
        .catch(error => reject(error))
    })
}

export const fetchGuideContent = async (id) => {
    const url = `/api/v1/readiness_guides/${id}`
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

export const fetchActivities = async () => {
    const url = `/api/v1/readiness_activities`
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

export const login = async (email, password) => {
    const url = `/api/v1/users/login`
    return new Promise((resolve, reject) => {
        axios.post(url, { user: { email: email, password: password }})
        .then(response => resolve(response)).catch(error => reject(error))
    })
}

// TODO: password confirmation is not being sent
export const register = async (first_name, last_name, email, password) => {
    return new Promise((resolve, reject) => {
        axios.post(`/api/v1/users/signup`,
        { user: { first_name, last_name, email, password }})
        .then(response => resolve(response)).catch(error => reject(error))
    })
}

export const fetchAccount = async () => {
    const url = `/api/v1/account`
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => response.data.status.data)
        .then(response => resolve(response)).catch(error => reject(error))
    })
}

export const logout = async () => {
    const url = `/api/v1/users/logout`
    return new Promise((resolve, reject) => {
        axios.delete(url, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => resolve(response)).catch(error => reject(error))
    })
}

export const fetchChildren = async () => {
    const url = `/api/v1/children`
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => response.data.status.data)
        .then(response => {
            resolve(response)
        })
        .catch(error => reject(error))
        
    })
}

export const fetchReadinessAssesment = async (id) => {
    const url = `/api/v1/readiness_assessments/${id}`
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => response.data.status.data)
        .then(response => {
            resolve(response)
        })
    })
}
// TODO: update 
export const fetchReadinessAssesments = async () => {
    const url = `/api/v1/readiness_assessments`
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => response.data.status.data)
        .then(response => {
            resolve(response.assessments)
        })
    })
}

export const patchReadinessAssessment = async (id, updateParams) => {
    const url = `/api/v1/readiness_assessments/${id}`
    return new Promise((resolve, reject) => {
        axios.patch(url, updateParams, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => {
            resolve(response.data.status.data)
        }).catch(error => reject(error))
    })
}

// TODO: update 
export const createChild = async (first_name, last_name, gender, birth_year, birth_month, preterm_weeks) => {
    return new Promise((resolve, reject) => {
        axios.post(`/api/v1/children`, 
            { child: { first_name, last_name, gender, birth_year, birth_month, preterm_weeks } }, 
            { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => {
            resolve(response.data.status.data)
        }).catch(error => reject(error))
    })
}

export const updateChild = async (id, first_name, last_name, gender, birth_year, birth_month, preterm_weeks) => {
    return new Promise((resolve, reject) => {
        axios.patch(`/api/v1/children/${id}`, 
            { child: { first_name, last_name, gender, birth_year, birth_month, preterm_weeks }}, 
            { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => {
            resolve(response.data.status.data)
        }).catch(error => reject(error))
    })
}

export const createReadinessAssessment = async (child_id, readiness_report_card_id, readiness_area_id) => {
    return new Promise((resolve, reject) => {
        axios.post(`/api/v1/readiness_assessments`, 
            { readiness_assessment: { child_id, readiness_report_card_id, readiness_area_id }}, 
            { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => {
            resolve(response.data.status.data)
        }).catch(error => reject(error))
    })
}

export const createReadinessReportCard = async (child_id) => {
    return new Promise((resolve, reject) => {
        axios.post(`/api/v1/readiness_report_cards`, { readiness_report_card: { child_id }}, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => {
            resolve(response.data.status.data)
        }).catch(error => reject(error))
    })
}

export const fetchReadinessReportCards = async () => {
    return new Promise((resolve, reject) => {
        axios.get(`/api/v1/readiness_report_cards`, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => response.data.status.data)
        .then(response => {
            resolve(response.readiness_report_cards)
        }).catch(error => reject(error))
    })
}

export const fetchReadinessReportCard = async (id) => {
    return new Promise((resolve, reject) => {
        axios.get(`/api/v1/readiness_report_cards/${id}`, { headers: { Authorization: `${localStorage.getItem('authToken')}` }})
        .then(response => response.data.status.data)
        .then(response => {
            resolve(response)
        }).catch(error => reject(error))
    })
}

export const updateUserPassword = async (reset_password_token, password, password_confirmation) => {
    return new Promise((resolve, reject) => {
        axios.put(`/api/v1/users/password`, { user: { reset_password_token, password, password_confirmation  }})
        .then(response => {
            resolve(response)
        }).catch(error => reject(error))
    })
}